import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { SEVERITY_COLORS } from "../constants/timelineSeverity";
import { formatTimelinePeriod } from "../utils/timelineFormatters";
import AnomalyInfoTip from "../../AnomalyInfoTip";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const DeviationChart = ({ t, dataPoints }) => {
  const anomalyPoints = useMemo(
    () => dataPoints.filter((dp) => dp.hasAnomaly && dp.maxDeviationPct != null),
    [dataPoints]
  );

  const chartData = useMemo(
    () => ({
      labels: anomalyPoints.map((dp) => formatTimelinePeriod(dp.period)),
      datasets: [
        {
          label: t("AnomalyDetection.deviationPct.label"),
          data: anomalyPoints.map((dp) => dp.maxDeviationPct),
          backgroundColor: anomalyPoints.map(
            (dp) => SEVERITY_COLORS[dp.maxSeverity] || "#94a3b8"
          ),
          borderRadius: 4,
        },
      ],
    }),
    [anomalyPoints, t]
  );

  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (ctx) => `${ctx.parsed.y?.toFixed(1)}%`,
          },
        },
      },
      scales: {
        x: { ticks: { font: { size: 10, family: "Inter, sans-serif" } } },
        y: {
          ticks: {
            font: { size: 11, family: "Inter, sans-serif" },
            callback: (v) => `${v}%`,
          },
        },
      },
    }),
    []
  );

  if (!anomalyPoints.length) return null;

  return (
    <div className="anomaly-chart-card">
      <div className="chart-card-header">
        <h6 className="chart-header-with-tip">
          {t("MetricAnomalyTimeline.deviationChart.label")}
          <AnomalyInfoTip text={t("MetricAnomalyTimeline.deviationChartTip.label")} />
        </h6>
      </div>
      <div className="chart-card-body">
        <div className="mat-chart-height mat-chart-height-sm">
          <Bar data={chartData} options={options} />
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(DeviationChart);
